import * as React from "react";
import { StackMapProvider } from "../../Stackmap";
import { AllCopies } from "../resource/AllCopies";
import { Navigate, useOutletContext } from "react-router-dom";
import {
  TitleTab,
  useLocationConfiguration,
} from "../../LocationConfiguration";
import { getDefaultTitleTabPath } from "../../TabUtils";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

export const AllCopiesPage: React.FC = () => {
  const resource = useOutletContext<ResourceDWR>();

  const { locationConfiguration } = useLocationConfiguration();

  if (resource.downloadable) {
    const nextPath = getDefaultTitleTabPath(
      locationConfiguration.pacSettings.titleDetailsTabSetups,
      [TitleTab.AllCopies]
    );

    return (
      <Navigate to={`/resource/${resource.id}/${nextPath}`} replace></Navigate>
    );
  }

  return (
    <StackMapProvider>
      <AllCopies resource={resource} />
    </StackMapProvider>
  );
};
